var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.75 20.125C3.43359 20.125 3.15234 20.0195 2.94141 19.8086C2.48438 19.3867 2.48438 18.6484 2.94141 18.2266L8.88281 12.25L2.94141 6.30859C2.48438 5.88672 2.48438 5.14844 2.94141 4.72656C3.36328 4.26953 4.10156 4.26953 4.52344 4.72656L11.2734 11.4766C11.7305 11.8984 11.7305 12.6367 11.2734 13.0586L4.52344 19.8086C4.3125 20.0195 4.03125 20.125 3.75 20.125Z","fill":"black"}));
}

MenuIcon.defaultProps = {"width":"12","height":"24","viewBox":"0 0 12 24","fill":"none"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
